<template>
    <img class="scene__instructions" src="../assets/img/instructions.png" alt="">
</template>
<script>
  export default {
    name: 'Instructions',
  }
</script>
